// src/components/PlotPointsTab.js
import React, { useState, useEffect } from 'react';

const PlotPointsTab = ({ data, onChange }) => {
  const [plotDetails, setPlotDetails] = useState(data.plotDetails || '');

  useEffect(() => {
    // Update the local state when the external data changes
    setPlotDetails(data.plotDetails || '');
  }, [data.plotDetails]);

  const handlePlotDetailsChange = (e) => {
    const updatedPlotDetails = e.target.value;
    setPlotDetails(updatedPlotDetails);
    onChange({ plotDetails: updatedPlotDetails });
  };



  return (
<div className='tab-styling'>
  <p className='synopsis-paragraph'>Time to prepare for the hard part. A long book has many twists and turns with various secondary characters, but a great way to figure out your plot points is to come back to your premise. What is the overall goal of your protagonist? What major steps are taken to reach that goal? What conflicts blocked their way?</p>
<div className="nice-form-group">
  
      <label>Plot Details</label>
      <textarea value={plotDetails} onChange={handlePlotDetailsChange} />
     </div>
     <p className='synopsis-paragraph'>Remember: A turning point is an event during the story where something unique or important occurs. This event will likely change your character's overall GMC.</p>
 
    </div>
  );
};

export default PlotPointsTab;
